import { SUPPORTED_LOCALES } from '../i18n/config';

/** AI投資情報の公開 URL（`/arena/econ`、言語付きは `/en/arena/econ` 等。本文は日本語） */
export function econReportPublicPath(locale: string, rest = ''): string {
  const suffix = rest ? `/${rest.replace(/^\/+/, '')}` : '';
  if (locale === 'ja' || locale.startsWith('ja-')) return `/arena/econ${suffix}`;
  if ((SUPPORTED_LOCALES as readonly string[]).includes(locale)) {
    return `/${locale}/arena/econ${suffix}`;
  }
  const short = locale.split('-')[0];
  if ((SUPPORTED_LOCALES as readonly string[]).includes(short)) {
    return `/${short}/arena/econ${suffix}`;
  }
  return `/arena/econ${suffix}`;
}

export function econReportDetailPath(locale: string, slug: string): string {
  return econReportPublicPath(locale, slug);
}

export function econReportCanonicalRedirect(pathname: string): string | null {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/ja/arena/econ' || path.startsWith('/ja/arena/econ/')) {
    return path.replace(/^\/ja/, '') || '/arena/econ';
  }
  return null;
}

/** 管理者用の作成・進行画面（公開パスには含めない） */
export const ECON_REPORT_COMPOSE_PATH = '/arena/econ/compose';

export function isEconReportComposePath(pathname: string): boolean {
  const path = pathname.replace(/\/+$/, '') || '/';
  return path === ECON_REPORT_COMPOSE_PATH;
}

/** 記事ページの slug を取り出す（ハブ・作成画面は null） */
export function parseEconReportSlugFromPath(pathname: string): string | null {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (!isEconReportPublicPath(path)) return null;
  const match = path.match(/\/arena\/econ\/([^/]+)$/);
  return match?.[1] ?? null;
}

export function isEconReportPublicPath(pathname: string): boolean {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (isEconReportComposePath(path)) return false;
  if (path === '/arena/econ' || path.startsWith('/arena/econ/')) return true;
  return SUPPORTED_LOCALES.some(
    (loc) => path === `/${loc}/arena/econ` || path.startsWith(`/${loc}/arena/econ/`)
  );
}
